import type { Settlement } from '../map/settlement';
import { ensureHouses } from '../map/settlement';
import type { BuildingType } from './buildingDefs';
import { BUILDING_DEFS } from './buildingDefs';

export type ConstructionItem = {
    id: string;
    building: BuildingType;
    cost: Record<string, number>;
    work: number;
    workRequired: number;
    startedTick: number;
};

export function queueConstruction(
    settlement: Settlement,
    building: BuildingType,
    startedTick: number,
    cost: Record<string, number> = {},
): ConstructionItem {
    settlement.construction.nextId += 1;
    const def = BUILDING_DEFS[building];
    const item: ConstructionItem = {
        id: `construction_${settlement.id}_${settlement.construction.nextId}`,
        building,
        cost,
        work: 0,
        workRequired: def.workRequired,
        startedTick,
    };
    settlement.construction.queue.push(item);
    return item;
}

export function applyConstructionComplete(settlement: Settlement, building: BuildingType): void {
    switch (building) {
        case 'house':
            settlement.buildings.houses += 1;
            ensureHouses(settlement);
            break;
        case 'stoneHouse':
            settlement.buildings.stoneHouse += 1;
            ensureHouses(settlement);
            break;
        case 'lumberjackCamp':
            settlement.buildings.lumberjack.qty += 1;
            break;
        case 'sawmill':
            settlement.buildings.sawmill.qty += 1;
            break;
        case 'farm':
            settlement.buildings.farm.qty += 1;
            break;
        case 'huntingHut':
            settlement.buildings.huntingHut.qty += 1;
            break;
        case 'fishingHut':
            settlement.buildings.fishingHut.qty += 1;
            break;
        case 'smokehouse':
            settlement.buildings.smokehouse.qty += 1;
            break;
        case 'weaver':
            settlement.buildings.weaver.qty += 1;
            break;
        case 'blacksmith':
            settlement.buildings.blacksmith.qty += 1;
            break;
        case 'goldMine':
            settlement.buildings.goldMine.qty += 1;
            break;
        case 'mint':
            settlement.buildings.mint.qty += 1;
            break;
        case 'caravanPost':
            settlement.buildings.caravanPost.qty += 1;
            break;
        case 'stable':
            settlement.buildings.stable.qty += 1;
            break;
        case 'quarry':
            settlement.buildings.quarry.qty += 1;
            break;
        case 'masonry':
            settlement.buildings.masonry.qty += 1;
            break;
        case 'charcoalPit':
            settlement.buildings.charcoalPit.qty += 1;
            break;
        case 'ironMine':
            settlement.buildings.ironMine.qty += 1;
            break;
        case 'smelter':
            settlement.buildings.smelter.qty += 1;
            break;
        case 'barracks':
            settlement.buildings.barracks.qty += 1;
            break;
        default:
            break;
    }
}
